import moment from 'moment';

export const excludeTimeFromDate = (date: Date | string) => moment(date).format('YYYY-MM-DD');

export const sortOtherLast = <E extends { other: 'other' }, T extends { id: E[keyof E]; name: string }>(
    enumObj: E,
    items: T[]
) =>
    items.sort((_a, b) => {
        if (b.id === enumObj.other) {
            return -1;
        }

        return 0;
    });
